// extracted by mini-css-extract-plugin
export default {"root":"TimeDisplay_root__b2rZX"};